var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { Field } from 'formik';
import { jsx } from 'theme-ui';
import FieldLayout from './FieldLayout';
import useFormTheme from './useFormTheme';
/**
 *
 * @param {{
 *  name: string; // The path to the field in lodash-like dot path, such as `social.facebook` or `friends[0].firstName`.
 *  value: string;
 *  label: string | JSX.Element; // The localized label.
 *  description?: string | JSX.Element; // The description.
 *  ignoreErrors?: boolean; // If set, error messages for individual radio buttons are hidden, so we can show them only once per radio.
 *  [x: string]: any;
 * }} props
 * @returns
 */
export default function RadioField(_a) {
    var { name, label, description, ignoreErrors } = _a, rest = __rest(_a, ["name", "label", "description", "ignoreErrors"]);
    const theme = useFormTheme();
    return (jsx(FieldLayout, { name: name, label: label, description: description, ignoreErrors: ignoreErrors },
        jsx(Field, Object.assign({ name: name, type: "radio", sx: theme === null || theme === void 0 ? void 0 : theme.radio }, rest))));
}
//# sourceMappingURL=RadioField.js.map